<template>
  <div class="actions-text">
    <div class="d-inline-block" v-for="(btn, index) in buttons" :key="`action-div-${index}`">
      <b-button variant="link" class="text-primary p-0" :class="btn.textClass" @click="$emit(btn.emitKey)">
        {{btn.text}}
      </b-button>
      <span class="ml-1 mr-1" v-if="index < buttons.length - 1">|</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ActionButtons",
    props: {
      view: {type: Boolean, default: true},
      edit: {type: Boolean, default: true},
      remove: {type: Boolean, default: true},
      viewPermission: {type: String, default: null},
      editPermission: {type: String, default: null},
      deletePermission: {type: String, default: null},
      extraActions: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        buttons: []
      };
    },
    mounted() {
      if (this.view && this.$hasPermission(this.viewPermission)) {
        this.buttons.push({
          text: this.$i18n.t('View'),
          emitKey: 'viewClick',
          textClass: 'text-primary',
        });
      }
      if (this.edit && this.$hasPermission(this.editPermission)) {
        this.buttons.push({
          text: this.$i18n.t('Edit'),
          emitKey: 'editClick',
          textClass: 'text-primary',
        });
      }
      if (this.remove && this.$hasPermission(this.deletePermission)) {
        this.buttons.push({
          text: this.$i18n.t('Delete'),
          emitKey: 'deleteClick',
          textClass: 'text-danger',
        });
      }
      if (this.extraActions && this.extraActions.length > 0) {
        for (let action of this.extraActions) {
          this.buttons.splice(action.index, 0, action.data)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
